exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na.button-regular[data-v-0acaf435] {\n  width: 118px;\n}\n.alert-error > label.input-label[data-v-0acaf435], .is-danger-msg[data-v-0acaf435] {\n  color: #B64242;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-0acaf435","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pages/ResetPassword.vue
// module id = 1805
// module chunks = 0